import React from 'react';
import logo from './dynamodb182.png';
import './App.css';

import ConnectWidget from './ConnectWidget';

import {LogPanel} from './LogPanel';

import {ActionButton} from './ActionButton';

import {TablesMenu} from './TablesMenu';
import {TableDetailsContainer} from './TableDetailsContainer';

import {stateReducer} from "./stateReducer";

import {StateProvider} from './state';

import DebugPanel from './DebugPanel';
import {Dashboard} from './Dashboard';


function App() {

    const initialState = {
        log:[
            'Welcome to BigBird Visualizer!',
            'Status messages are logged here.',
            'Click a button above to connect to DynamoDB.'
        ],
        operation:{
            'target':null,
            'action':null
        },
        connection: null,
        metadata: []

    };

  return (
      <StateProvider initialState={initialState}  reducer={stateReducer}>

        <div className="App">

          <header className="App-header">
            <a href="/" >
              <img src={logo} className="App-logo" alt="logo"  />
            </a>

            <span className="App-title" >
                    DynamoDB Visualizer
            </span>

            <span className="App-header-right" >

                <ConnectWidget/>

                {/*<ActionButton msg='unicorn' />*/}

            </span>

          </header>

          <nav className="App-nav">

            <TablesMenu />

            {/*<br/>*/}
            {/*<Dashboard />*/}

          </nav>

          <main className="App-main">

              <TableDetailsContainer />

          </main>

          <div className="sidebar1" >

              <ActionButton msg="clear log"  />

              <LogPanel />

          </div>

          <div className="sidebar2" >


          </div>

          <footer className="App-footer">
              <span className='feedback' >
                  A data browser that calls DynamoDB directly, built using React Hooks.

                  {/*Point this to your table!  See <a className='feedback' href="https://github.com/robm26/dv">github.com/robm26/dv</a>*/}
              </span>

            <DebugPanel />

          </footer>

        </div>
      </StateProvider>
  );
}

// export default withAuthenticator(App, true);
export default App;

